export enum FeatureToggle {
  campaignManagement = 'campaignManagement',
  campaignManagementRedemptionUrls = 'rt_redemption_urls',
  campaignManagementMultiRetailerPages = 'rt_multi_retailer_pages',
  adminMezcalPages = 'rt_admin_mezcal_pages',
  flyoutsOnCreativeManager = 'rt_flyout_on_creative_manager',
  adminCalendarPage = 'rt_campaigns_admin_calendar_enabled',
  adminCreativesPage = 'rt_campaigns_admin_creatives_enabled',
  universalValueCarousel = 'rt_universal_value_carousel',
  retailerForwardList = 'rt_retailer_forward_list',
  retailerForwardListImageRow = 'rt_retailer_forward_list_image_row',
  universalValueCarouselSlot = 'rt_uvc_slot',
  multiRetailerPageSlots = 'rt_multi_retailer_page_slots',
  multiRetailerPageMakeUniqueSlots = 'rt_multi_retailer_page_make_unique_slots',
  multiRetailerRichText = 'rt_multi_retailer_rich_text',
  multiRetailerFaqs = 'rt_multi_retailer_faqs',
  multiRetailerPageItemListImageRow = 'rt_multi_retailer_page_item_list_image_row',
  multiRetailerHeaderBannerSettings = 'rt_multi_retailer_header_banner_settings',
  multiRetailerLocalizationRowEnabled = 'rt_multi_retailer_localization_row_enabled',
  multiRetailerItemListPinnedProducts = 'rt_multi_retailer_item_list_pinned_products',
  multiRetailerItemListItemCountThreshold = 'rt_multi_retailer_item_list_item_count_threshold',
  mrpFullWidthBannerFullBleed = 'rt_mrp_full_width_banner_full_bleed',
  mrpFullWidthBannerDisclaimer = 'rt_mrp_full_width_banner_disclaimer',
  userLoyaltyVisibilityCondition = 'rt_user_loyalty_visibility_condition',
  landingPageSlots = 'rt_landing_page_slots',
  icPlusBenefitsSlot = 'rt_ic_plus_benefits_slot',
  landingValuePropRichText = 'rt_landing_value_prop_rich_text',
  enhancedRichTextEditor = 'rt_enhanced_rich_text_editor',
  contentCardCarousel = 'rt_content_card_carousel',
  warehouseContentCardCarousel = 'rt_warehouse_content_card_carousel',
  aiCarouselCreatorM2 = 'rt_ai_carousel_creator_m2',
  retailerCreateDigitalFlyerEnabled = 'rt_warehouse_create_digital_flyer',
}
